module.exports = __webpack_public_path__ + "img/product02.435a4396.png";